import { render, staticRenderFns } from "./b-select-professional.vue?vue&type=template&id=392255d5&scoped=true&"
import script from "./b-select-professional.vue?vue&type=script&lang=js&"
export * from "./b-select-professional.vue?vue&type=script&lang=js&"
import style0 from "./b-select-professional.vue?vue&type=style&index=0&id=392255d5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "392255d5",
  null
  
)

export default component.exports